import { useStoreMutation } from '@client/queries/useStoreMutation';
import { useStoreQuery } from '@client/queries/useStoreQuery';
import {
  listMarketplace,
  listMarketplaceFeatures,
  setMarketplaceFeatured,
  setMarketplaceFeatureFeatured,
  type IMarketplaceFeaturesListResponse,
  type IMarketplaceListParams,
  type IMarketplaceListResponse,
} from '@client/services/marketplace.service';

// Query keys
export const marketplaceKeys = {
  all: ['marketplace'] as const,
  lists: () => [...marketplaceKeys.all, 'list'] as const,
  list: (filters: IMarketplaceListParams) =>
    [...marketplaceKeys.lists(), filters] as const,
  featuresAll: ['marketplace', 'features'] as const,
  featuresLists: () => [...marketplaceKeys.featuresAll, 'list'] as const,
  featuresList: (filters: IMarketplaceListParams) =>
    [...marketplaceKeys.featuresLists(), filters] as const,
};

export const useMarketplaceQueries = () => {
  // Get marketplace list (public sub-list)
  const useMarketplaceList = (params: IMarketplaceListParams = {}) =>
    useStoreQuery<IMarketplaceListResponse>({
      queryKey: marketplaceKeys.list(params),
      queryFn: () => listMarketplace(params),
    });

  // Toggle featured flag (admin)
  const useSetFeatured = () =>
    useStoreMutation({
      mutationFn: ({ id, featured }: { id: string; featured: boolean }) =>
        setMarketplaceFeatured(id, featured),
      invalidateQueries: [marketplaceKeys.lists()],
    });

  // Step 5: features marketplace
  const useMarketplaceFeaturesList = (params: IMarketplaceListParams = {}) =>
    useStoreQuery<IMarketplaceFeaturesListResponse>({
      queryKey: marketplaceKeys.featuresList(params),
      queryFn: () => listMarketplaceFeatures(params),
    });

  const useSetFeatureFeatured = () =>
    useStoreMutation({
      mutationFn: ({ id, featured }: { id: string; featured: boolean }) =>
        setMarketplaceFeatureFeatured(id, featured),
      invalidateQueries: [marketplaceKeys.featuresLists()],
    });

  return {
    useMarketplaceList,
    useSetFeatured,
    useMarketplaceFeaturesList,
    useSetFeatureFeatured,
  };
};
